module.exports = __webpack_public_path__ + "4.3.2/img/ydkey.a92100f5.png";